import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItemButton, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFamilyNameList } from '../../fetch/fetchClassificationItems';

export default function FamilySelectModal({ open, fault, onClose }) {
    const navigate = useNavigate();
    const { familyNames } = useFamilyNameList(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const menuOpen = !!anchorEl;

    useEffect(() => {
        setSelectedFamily(null);
    }, [open]);

    if (!fault || !fault.familyNames) {
        return null;
    }

    const { familyNames: familyNamesText } = (fault || {});
    const matchingFamilies = familyNames.filter(it => familyNamesText.indexOf(it.name) >= 0);

    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (_event, familyName) => {
        setSelectedFamily(familyName)
        setAnchorEl(null);
    };

    const handleNavigate = () => {
        let moduleParam = '';
        if (!!fault.moduleTypes && fault.moduleTypes.length === 1) {
            moduleParam = `?moduleTypeId=${fault.moduleTypes[0]}`;
        }

        const legacy = fault.universalFaultId == null || fault.universalConditionId == null;

        const viewUrl = !legacy ?
            `/literature/fault/${selectedFamily.id}/${fault.universalFaultId}-${fault.universalConditionId}${moduleParam}` :
            `/literature/fault/legacy/${selectedFamily.id}/${fault.engineeringNames[0]}`;

        navigate(viewUrl);
    }

    return (
        <Dialog
            open={open}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            onClose={onClose}
        >
            <DialogTitle id="dialog-title">Select a Family</DialogTitle>
            <DialogContent id="dialog-description">
                <List component='nav' aria-label='fault-family' style={{ padding: 0, minWidth: '20em' }}>
                    <ListItemButton
                        id='fault-family-button'
                        aria-haspopup="listbox"
                        aria-controls="fault-family-menu"
                        aria-label="fault family"
                        aria-expanded={menuOpen ? 'true' : undefined}
                        onClick={handleClickListItem}
                    >
                        <ListItemText
                            primary={!!selectedFamily ? selectedFamily?.name : "Select Family"}
                        />
                    </ListItemButton>
                </List>

                <Menu
                    id="fault-family-menu"
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleMenuClose}
                    MenuListProps={{
                        'aria-labelledby': 'fault-family-button',
                        role: 'listbox',
                    }}
                >
                    {!selectedFamily ? (
                        <MenuItem
                            selected={!selectedFamily}
                            onClick={(event) => handleMenuItemClick(event, null)}
                        >
                            Select Family
                        </MenuItem>
                    ) : null}
                    {(matchingFamilies || []).map((familyName) => (
                        <MenuItem
                            key={familyName.id}
                            selected={familyName.id === selectedFamily?.id}
                            onClick={(event) => handleMenuItemClick(event, familyName)}
                        >
                            {familyName.name}
                        </MenuItem>
                    ))}
                </Menu>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                {!!selectedFamily ? (
                    <Button onClick={handleNavigate}>Open</Button>
                ) : null}
            </DialogActions>
        </Dialog>
    )
}